module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temporal-notification"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showState) ? _c('div', {
    staticClass: "modal on-top is-active"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification has-text-centered is-rounded",
    class: _vm.notificationClass
  }, [_vm._t("default")], 2)])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8df17170"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TemporalNotification.vue
// module id = 441
// module chunks = 0